import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import carrousel1 from '../assets/img/carrousel1.jpg';
import carrousel2 from '../assets/img/carrousel2.webp';
import carrousel3 from '../assets/img/carrousel3.webp';

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500, // Ralenti significativement
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000, // Changement toutes les 8 secondes
    fade: true, // Effet de fondu entre les slides
    cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)' // Courbe de transition personnalisée
  };

  const carouselContainerStyle = {
    width: '100%',
    height: '75vh', // 1.5x plus long (environ 75% de la hauteur d'écran)
    overflow: 'hidden',
    position: 'relative'
  };

  const imageStyle = {
    width: '100%',
    height: '75vh',
    objectFit: 'cover',
    objectPosition: 'center'
  };

  return (
    <div style={carouselContainerStyle}>
      <Slider {...settings}>
        <div>
          <img src={carrousel1} style={imageStyle} alt="Présentation financement" />
        </div>
        <div>
          <img src={carrousel2} style={imageStyle} alt="Accompagnement personnalisé" />
        </div>
        <div>
          <img src={carrousel3} style={imageStyle} alt="Solutions clés en main" />
        </div>
      </Slider>
    </div>
  );
};

export default Carousel;